import React from 'react'
import { BasePage } from './BasePage'
import { Orders } from './Orders'

export const OrderPage = ({ match, location }) => {
  return (
    <React.Fragment>
      <BasePage
        Comp={() =>
          Orders({
            coursenum: match.params.coursenum,
            pageNum: location.search.split('page_num=')[1],
          })
        }
      />
    </React.Fragment>
  )
}
